export default __webpack_public_path__ + "static/media/ServicesMainRegister1.d736fa50.svg";